import React, { useState } from "react";
import Services from "../../services/Services";
import ISupportCall from "../../models/ISupportCall";
import IServiceCallNote from "../../models/IServiceCallNote";
import { RouteComponentProps, Redirect } from "react-router";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import { selectAuth } from "../../store/auth/selectors";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import snackbarService from "../../services/ui-messaging/SnackbarService";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";
import SCDetailTicketInfo from "./SCDetailTicketInfo";
import SCDetailNotes from "./SCDetailNotes";

interface ISCDetailComponentProps extends RouteComponentProps<{ ticketNumber: string }> {
  token: string;
  companyId: number;
}

interface ISCDetailState {
  ticket: ISupportCall;
  notes: IServiceCallNote[];
  isLoading: boolean;
}

class ServiceCallDetail extends React.Component<ISCDetailComponentProps, ISCDetailState> {
  constructor(props: ISCDetailComponentProps) {
    super(props);

    this.state = {
      ticket: {
        status: "",
        summary: "",
        submittedBy: "",
        type: "",
        menuPath: "",
        id: "0",
        dateSubmitted: "",
        description: "",
        product: "",
        productType: "",
        labelPath: "",
        module: "",
        object: "",
        screen: "",
        integrationID: "",
      },
      notes: [],
      isLoading: false,
    };

    this.getServiceCall = this.getServiceCall.bind(this);
    this.getServiceCallNotes = this.getServiceCallNotes.bind(this);
    this.updateServiceCallNotes = this.updateServiceCallNotes.bind(this);
  }

  services: Services = new Services();

  async updateServiceCallNotes() {
    await this.getServiceCallNotes();
  }

  async getServiceCall() {
    this.setState({ isLoading: true });
    try {
      const scRepo = await this.services.ServiceCallRepository();
      var resp = await scRepo.GetServiceCall(this.props.token, this.props.match.params.ticketNumber);
      this.setState({ ticket: resp, isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
      snackbarService.error(error || "An error occurred while retrieving support ticket details");
    }
  }

  async getServiceCallNotes() {
    try {
      this.setState({ isLoading: true });
      const scRepo = await this.services.ServiceCallNoteRepository();

      var resp = await scRepo.GetServiceCallNotes(this.props.token, this.props.match.params.ticketNumber);
      this.setState({ notes: resp, isLoading: false });
    } catch (error) {
      snackbarService.error(error || "An error occurred while retrieving support ticket note details");
    }
  }

  async componentDidMount() {
    await this.getServiceCall();
    await this.getServiceCallNotes();
  }

  render() {
    return (
      <>
        <ScrollToTopOnMount />
        <WithLoadingSpinners message="Getting ticket details" isLoading={this.state.isLoading}>
          <SCDetailTicketInfo ticket={this.state.ticket} token={this.props.token} updateNotes={this.updateServiceCallNotes} />
          <SCDetailNotes notes={this.state.notes} />
        </WithLoadingSpinners>
      </>
    );
  }
}

export default connect((state: IApplicationState) => {
  return selectAuth(state);
})(ServiceCallDetail);
